window.addEventListener('load', () => {
    var discCookie = document.querySelector('.disc-cookie');
    var discCookieAgree = document.querySelector('.disc-cookie__agree');

    var getCookie = function (cookieName) {
      const matches = document.cookie.match(new RegExp("(?:^|; )" + cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    var setCookie = function (cookieName, cookieValue) {
      document.cookie = cookieName + "=" + cookieValue + "; path=/; max-age=" + 86400;
    };

    var cookieAgree = getCookie('agreeCookie');

    if (!cookieAgree && discCookie) {
        discCookie.style.display = 'flex';
    }
    
    if (discCookieAgree) {
        discCookieAgree.addEventListener('click', function(){
            setCookie('agreeCookie', 'yes');
            discCookie.style.display = 'none';
        });
    }
});